import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class GatewayFNOLService {
    static submitClaim(data, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayFnol'),
            'submitClaim',
            [data],
            additionalHeaders
        );
    }

    static getFNOLDetails(policyNumber, data, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayFnol'),
            'createClaim',
            [policyNumber, data],
            additionalHeaders
        );
    }

    static getClaim(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayFnol'),
            'getClaim',
            [claimNumber],
            additionalHeaders
        );
    }

    static saveFNOLDetails(data, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayFnol'),
            'saveClaim',
            [data],
            additionalHeaders
        );
    }

    static searchPolicies(policySearchCriteria, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayFnolPolicy'),
            'searchPolicies',
            [policySearchCriteria],
            additionalHeaders
        );
    }

    static getPolicySummaryRiskUnits(
        policyNumber,
        lossDate,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayFnolPolicy'),
            'getPolicySummaryRiskUnits',
            [policyNumber, lossDate],
            additionalHeaders
        );
    }

    static getLossDamageExtDTO(claimNumber, riskPublicID,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayClaim'),
            'getLossDamageExtDTO',
            [claimNumber,riskPublicID],
            additionalHeaders
        );
    }

    static getLossDamagesExtDTO(claimNumber, riskPublicID,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayClaim'),
            'getLossDamagesExtDTO',
            [claimNumber,riskPublicID],
            additionalHeaders
        );
    }

    static createOrUpdateLossDamagesExt(claimNumber, lossDamages,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayClaim'),
            'createOrUpdateLossDamagesExt',
            [claimNumber,lossDamages],
            additionalHeaders
        );
    }

    static getLocationBasedRUs(claimNumber, withLossDamageReportsOnly,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayClaim'),
            'getLocationBasedRUs',
            [claimNumber,withLossDamageReportsOnly],
            additionalHeaders
        );
    }

    static deleteClaimLossDamageExtByLocationRU(claimNumber, lossDamageId, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayFnol'),
            'deleteClaimLossDamageExtByLocationRU',
            [claimNumber,lossDamageId],
            additionalHeaders
        );
    }

    static updateClaimLossDamageExt(claimNumber, lossDamageExtDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayClaim'),
            'updateClaimLossDamageExt',
            [claimNumber,lossDamageExtDTO],
            additionalHeaders
        );
    }

    static createClaimLossDamageExt(claimNumber, lossDamageExtDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayClaim'),
            'createClaimLossDamageExt',
            [claimNumber,lossDamageExtDTO],
            additionalHeaders
        );
    }

    static deleteClaimLossDamageExt(claimNumber, lossDamageExtDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayClaim'),
            'deleteClaimLossDamageExt',
            [claimNumber, lossDamageExtDTO],
            additionalHeaders
        );
    }

}
